"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.ImageContainer = exports.Image = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ImageContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 30px 16px;\n\n  justify-content: ", ";\n\n  @media (min-width: 768px) {\n    padding: 60px 20px;\n  }\n"])), function (props) {
  console.log(props);
  return props.isEven ? 'flex-end' : 'flex-start';
});

exports.ImageContainer = ImageContainer;

var ImageWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n\n  @media (min-width: 768px) {\n    max-width: 66%;\n  }\n"])));

exports.ImageWrapper = ImageWrapper;

var Image = _styledComponents.default.img(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  transform-origin: center center;\n"])));

exports.Image = Image;